<div class="w-full h-full flex flex-grow-0 gap-5">
  <div class="w-1/4 h-full">
    <div
      class="w-full overflow-y-auto rounded-md bg-slate-50 p-2"
      [style.height]="'calc(100% - 3rem)'"
    >
      <div class="flex flex-col w-full gap-2">
        @if (selectedProducts().length === 0) {
          <div
            class="w-full text-lg text-gray-500 flex items-center justify-center py-5"
          >
            No products selected.
          </div>
        }
        @for (product of selectedProducts(); track product.ext_id) {
          <div
            class="h-20 flex items-center justify-between px-2 py-1 bg-white rounded-md"
          >
            <div class="flex items-center gap-2">
              <div class="aspect-square rounded-md h-12 w-12">
                <img
                  [lazyLoad]="product.cdn_image"
                  class="h-full w-full object-contain"
                />
              </div>
              <div>{{ product.name }}</div>
            </div>
            <div>
              <confect-icon-button
                icon="delete"
                iconClass="text-2xl hover:text-red my-2"
                (click)="removeProduct(product)"
              />
            </div>
          </div>
        }
      </div>
    </div>
    <div class="w-full h-[3rem] flex items-end justify-center">
      <confect-button
        type="primary"
        class="w-full"
        [block]="true"
        (click)="apply()"
        >Apply</confect-button
      >
    </div>
  </div>
  <div class="w-3/4 h-full">
    <div class="w-full h-full">
      <confect-input
        inputIcon="search"
        placeholder="Search for ID, name, brand, category, etc."
        [ngModel]="searchString()"
        (ngModelChange)="searchString.set($event); searchChange.next(true)"
      />
      <div class="pt-5 w-full table-height">
        <ngx-confect-table
          [scroll]="true"
          [infiniteScroll]="true"
          (loadMore)="loadNextPage($event)"
          [header]="[
            { name: '', key: 'cdn_image' },

            { name: 'ID', key: 'ext_id' },
            { name: 'Name', key: 'name' },
            { name: 'Brand', key: 'brand' },
            { name: 'Price', key: 'price' },
          ]"
          [rows]="searchResultProducts()"
        >
          <ng-template tableBody let-rows="rows" let-cols="cols">
            @for (row of rows; track row.id; let i = $index) {
              <tr
                class="bg-white hover:bg-gray-100 cursor-pointer"
                [ngClass]="{
                  'bg-white': i % 2 === 0,
                  'bg-gray-50': i % 2 === 1,
                }"
                (click)="
                  checkSelected()[row.ext_id]
                    ? removeProduct(row)
                    : addProduct(row)
                "
              >
                @for (col of cols; track col; let i = $index) {
                  <td
                    class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-700 text-ellipsis truncate cursor-pointer"
                  >
                    @if (col.key === "cdn_image") {
                      <div class="w-full justify-between flex items-center">
                        <confect-checkbox
                          class="pointer-events-none"
                          [value]="checkSelected()[row.ext_id]"
                        />
                        <div class="aspect-square rounded-md h-12 w-12">
                          <img
                            [lazyLoad]="row[col.key]"
                            class="h-full w-full object-contain"
                          />
                        </div>
                      </div>
                    } @else {
                      {{ row[col.key] ?? "-" }}
                    }
                  </td>
                }
              </tr>
            }
          </ng-template>
        </ngx-confect-table>
      </div>
    </div>
  </div>
</div>
